<template>
    <el-dialog
    v-model="mostrarDialog"
    :show-close="false"
    :close-on-click-modal="false"
    custom-class="recibo"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    class="recibo-dialog"
  >
    <template #header>
        <el-row type="flex" justify="center" >
            {{$t('RESUMENDECUENTA_recibo') + ' '+ recibo.Cabecera.TipoDocumento + ' ' + recibo.Cabecera.SerieDocumento + ' ' + recibo.Cabecera.SucursalDocumento + ' ' + recibo.Cabecera.NumeroDocumento}}
        </el-row>
    </template>
    <div>
        <el-row>
            <el-card class="recibo" id="recibo"  ref="recibo">
                <div class="cabecera">
                    <el-row type="flex" align="middle" class="hidden-xs-only">
                        <el-col :sm="11">
                            <el-row type="flex" justify="space-between"> 
                                <div class="title">{{$t('RESUMENDECUENTA_fecha')}}:</div>
                                <div>{{ $filters.formatDate(recibo.Cabecera.Fecha) }}</div>
                            </el-row>
                            <el-row type="flex" justify="space-between">
                                <div class="title">
                                    {{$t('RESUMENDECUENTA_cliClave')}}:
                                </div>
                                <div>{{recibo.Cabecera.CliClave}}</div>
                            </el-row>
                        </el-col>
                        <el-col :sm="2">
                            <el-divider direction="vertical"></el-divider>
                        </el-col>
                        <el-col :sm="11">
                            <el-row type="flex" justify="space-between">
                                <div class="title">{{$t('RESUMENDECUENTA_razonSocial')}}:</div>
                                <div>{{recibo.Cabecera.RazonSocial}}</div>
                            </el-row>
                            <el-row type="flex" justify="space-between">
                                <div class="title">{{$t('RESUMENDECUENTA_importeTotal')}}:</div>
                                <div>{{recibo.Cabecera.MonedaDocumento}} {{ $filters.formatPrice(recibo.Cabecera.MontoTotal) }}</div>
                            </el-row>
                        </el-col>
                    </el-row>
                    <div class="hidden-sm-and-up">
                        <el-row type="flex" justify="space-between"> 
                            <div class="title">{{$t('RESUMENDECUENTA_fecha')}}:</div>
                            <div>{{ $filters.formatDate(recibo.Cabecera.Fecha) }}</div>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <div class="title">
                                {{$t('RESUMENDECUENTA_cliClave')}}:
                            </div>
                            <div>{{recibo.Cabecera.CliClave}}</div>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <div class="title">{{$t('RESUMENDECUENTA_razonSocial')}}:</div>
                            <div>{{recibo.Cabecera.RazonSocial}}</div>
                        </el-row>
                        <el-row type="flex" justify="space-between">
                            <div class="title">${{$t('RESUMENDECUENTA_importeTotal')}}:</div>
                            <div>{{recibo.Cabecera.MonedaDocumento}} {{ $filters.formatPrice(recibo.Cabecera.MontoTotal) }}</div>
                        </el-row>
                    </div>
                    <el-row type="flex" align="middle">
                        <div class="title concepto">{{$t('RESUMENDECUENTA_concepto')}}:</div>
                        <div>{{recibo.Cabecera.Concepto}}</div>
                    </el-row>
                </div>
                <div>
                    <el-table
                        :data="recibo.Detalles"
                        header-row-class-name="table-header"
                        :header-cell-style="() => 'text-align: left;'"
                    >
                        <el-table-column
                            prop="Tipo"
                            :label="$t('RESUMENDECUENTA_tipoDocumento')"
                            width="60"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="Numero"
                            :label="$t('RESUMENDECUENTA_numero')"
                            width="100"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="Banco"
                            :label="$t('RESUMENDECUENTA_banco')"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="Sucursal"
                            :label="$t('RESUMENDECUENTA_sucursal')"
                        >
                        </el-table-column>
                        <el-table-column
                            :label="$t('RESUMENDECUENTA_importe')"
                            width="100"
                            align="right"
                        >
                            <template #default="scope" >
                                {{ $filters.formatPrice(scope.row.Importe) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-card>
        </el-row>
    </div>

    <template #footer>
        <span class="dialog-footer">
            <el-row>
                <el-button @click="aceptar">{{$t('GENERAL_acceptBtn') }}</el-button>
            </el-row>
        </span>
    </template>
  </el-dialog>
</template>
<script>
export default {
    name: 'reciboDialog',
    props: {
      recibo: {
        type: Object
      },
      visible: {
        type: Boolean,
        required: true
      },
      onClose: {
        type: Function,
        required: true
      }
    },
    data(){
      return {
        mostrarDialog: false
      }
    },
    methods: {
      aceptar(){
        this.mostrarDialog = false;
        this.onClose();
      }
    },
    watch: {
      visible() {
        this.mostrarDialog = this.visible;
      }
    }
  }
</script>
<style scoped media="print">
.el-divider--vertical {
    height: 5rem !important;
    background-color: var(--main-color);
}
.cabecera .title {
    color: black;
    font-weight: bold;
    font-size: 15px;
}
.cabecera .concepto {
    margin-right: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
}
.el-button {
    padding: 12px 20px !important;
}
@media print {
    .el-divider--vertical {
        height: 5rem !important;
        background-color: var(--main-color);
    }
    .cabecera .title {
        color: black;
        font-weight: bold;
        font-size: 15px;
    }
    .cabecera .concepto {
        margin-right: 10px;
        margin-top: 5px;
        margin-bottom: 5px;
    }
    .el-card {
                border-top: 4px solid var(--main-color) !important;
                width: 100% !important;
            }
            .el-table th>.cell {
                color: #595959;
            }

            .el-table tr {
                cursor: pointer;
            }
            .el-table .table-header > th{
                background-color: var(--main-color) !important;
                color: white !important;
                font-weight: bold;
                text-align: left;
                padding-top: 0px; 
                padding-bottom: 0px;
            }
            .el-dialog{
                border-radius: 8px !important;
                border-top: 8px solid var(--main-color);
                text-align: left;
            }
            .el-dialog__title{
                font-size: 22px !important;
                font-weight: bold !important;
                text-align: left !important;
                color: var(--main-color) !important;
                margin-bottom: 20px !important;
                text-align: left !important;
            }
            .el-dialog__body{
                border-top: 1px solid #ececec;
                border-bottom: 1px solid #ececec;
                margin-left: 10px;
                margin-right: 10px;
            }
}
</style>
<style>
.recibo .el-dialog__header {
    background-color: var(--main-color);
    color: #ffffff;
    font-size: 1em;
    font-weight: bold;
    padding: 10px 0 10px 20px;
}
.recibo .el-dialog__body {
    padding: 20px 0px;
}

</style>